import React from "react";
import { TEST_IDS } from "@/lib/testIds";
import { PHOTOS } from "@/lib/links";

export const About = () => {
  return (
    <section
      id="about"
      data-testid={TEST_IDS.about.section}
      className="bg-paper py-28 md:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <div className="lg:col-span-5">
            <div className="relative">
              <div className="absolute -inset-4 md:-inset-6 bg-paperdeep -z-10" />
              <div className="aspect-[4/5] overflow-hidden bg-paperdeep">
                <img
                  src={PHOTOS.lizOutdoor}
                  alt="Liz Dirocco, financial educator"
                  data-testid={TEST_IDS.about.headshot}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="absolute -bottom-5 -right-5 bg-paper border border-paperdeep px-5 py-4 hidden md:block">
                <p className="font-serif italic text-nearblack text-xl leading-none">
                  Liz Dirocco
                </p>
                <p
                  className="text-camel mt-1.5"
                  style={{ fontSize: "0.62rem", letterSpacing: "0.32em", textTransform: "uppercase" }}
                >
                  Educator · IBC Practitioner
                </p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 lg:pt-8">
            <p className="eyebrow mb-7">About Liz</p>
            <h2
              className="font-serif text-nearblack leading-[1.06] text-balance"
              style={{ fontSize: "clamp(2rem, 3.6vw, 3.4rem)", fontWeight: 400 }}
            >
              An educator first.
              <br />
              <em className="italic text-camel">
                A systems thinker, always.
              </em>
            </h2>

            <div className="mt-9 space-y-6 text-nearblack/80 text-[16px] md:text-[17px] leading-[1.85] font-light max-w-2xl">
              <p>
                I’ve always been curious why some people can earn a good
                income and still feel financially stressed, stuck, or
                uncertain about the future. It’s a quiet pattern I kept
                noticing — in friends, in clients, in conversations that had
                nothing to do with money on the surface.
              </p>
              <p>
                The deeper I got into personal finance, the more I realized
                most conversations focus on products, rates, investments, and
                returns — while very few focus on the structure underneath it
                all. That observation slowly pulled me toward systems thinking
                and, eventually, the Infinite Banking Concept.
              </p>
              <p>
                Today I work primarily with responsible high-income earners,
                business owners, and growing families who want more control,
                clarity, and flexibility with their money. I see myself as an
                educator first — less interested in selling products, more
                interested in helping people understand how money actually
                moves through their lives.
              </p>
              <p>
                Better financial decisions come from understanding the system
                you’re operating within. My work is about helping you see that
                system clearly and build a structure that supports your
                long-term goals — quietly, intentionally, and on your terms.
              </p>
            </div>

            <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-4">
              {[
                "Educator",
                "Systems Thinker",
                "Long-Term Focus",
                "IBC Practitioner",
              ].map((tag) => (
                <div
                  key={tag}
                  className="border-t border-camel/40 pt-3"
                  style={{ fontSize: "0.65rem", letterSpacing: "0.32em", textTransform: "uppercase", color: "#8C8478", fontWeight: 500 }}
                >
                  {tag}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
